
<template>
  <div>
    <div>
      <v-checkbox v-model="new_building" label="Cadastrar nova obra"></v-checkbox>
      <div v-if="new_building">
        <BuildingForm ref="forms1" :building="shipping.building_attributes"></BuildingForm>
        <AddressForm ref="forms2" :address="shipping.building_attributes?.address_attributes"></AddressForm>
      </div>
    </div>
    <div>
      <v-form ref="forms3">
        <v-select return-object :disabled="new_building" :loading="loading" :items="buildings" v-model="shipping.building" label="Selecione a obra" :rules="required_id"
          prepend-icon="mdi-domain" item-text="attributes.name" item-value="id">
          <template v-slot:selection="{item}">
            <span>{{ item.attributes.name }}</span>
            <span class="ml-2 caption">({{ item.attributes.full_address }})</span>
          </template>
          <template v-slot:item="{item}">
            <span>{{ item.attributes.name }}</span>
            <span class="ml-2 caption">({{ item.attributes.full_address }})</span>
          </template>
          <template slot="append">
            <v-btn class="ma-1" text small @click="getBuildings">
              <v-icon left small>mdi-reload</v-icon>
              <span>Recarregar obras</span>
            </v-btn>
          </template>
        </v-select>
      </v-form>
      <div v-if="buildings.length == 0 && !loading" class="pt-3">
        <v-alert type="info" icon="mdi-alert" :value="true">
          Nenhuma obra cadastrada.
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api/index'
import validations from '@/mixins/validations'
import cimentao_links from "@/mixins/cimentao_links";

export default {
  name: 'BuildingSelect',
  components:{
    BuildingForm: ()=> import("@/_backoffice/_registrations/components/buildings/forms/BuildingForm.vue"),
    AddressForm: ()=> import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
  },
  props: {
    shipping: {
      type: Object,
    },
    client_id:{
      type: [String, Number]
    }
  },
  mixins: [ validations, cimentao_links ],
  data() {
    return {
      loading: false,
      new_building: false,
      buildings: [],
      required_id: [v => !!v.id || "Campo obrigatório"]
    }
  },
  methods: {
    validate(){
      if(this.new_building){
        return this.$refs.forms1.validate() && this.$refs.forms2.validate()
      }else{
        return this.$refs.forms3.validate()
      }
    },
    getBuildings(){
      let client_id = this.client_id 
      if(client_id){
        let ACTIVE_STATUS = 10
        this.loading = true
        Api.Building.index({client_id, status: ACTIVE_STATUS}).then((res)=>{
          this.buildings = [ ...res.data.data ]
        }).finally(()=>{
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.getBuildings()
  },
  watch: {
    client_id(nv){
      this.getBuildings()
    },
    new_building(nv){
      if(nv){
        this.shipping.building = { id: null }
      }else{
        this.shipping.building_attributes = {
          address_attributes: {}
        }
      }
    }
  },
}
</script>